import {Component, Inject, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {MatPaginator} from '@angular/material/paginator';
import {MatTableDataSource, MatTableDataSourcePaginator} from '@angular/material/table';
import {AlertArgumentarioComponent} from '../../../VistasGenericas/alert-argumentario/alert-argumentario.component';
import {PeticionOutbound, PeticionWeb, PeticionWebNew, PeticionWebRauda} from '../../models/PeticionWeb';
import {VentanaFlotante} from '../../models/VentanaFlotante';
import {GestionPeticionService} from '../../services/bd/GestionPeticion/gestion-peticion.service';
import {DetallePeticionComponent} from '../detalle-peticion/detalle-peticion.component';
import {UsuarioService} from "../../services/user.service";
import {MatSort} from "@angular/material/sort";
import {traducirTipoGestion,traducirEstadoPeticionWeb,convertirPeticionWebAPeticionWebNew} from '../../models/PeticionWeb';
@Component({
  selector: 'ral-gestion-peticion-web',
  templateUrl: './gestion-peticion-web.component.html',
  styleUrls: ['./gestion-peticion-web.component.scss']
})
export class GestionPeticionWebComponent extends VentanaFlotante
{
  token:string ="";
  fechaInicio:Date = new Date();
  fechaFin:Date = new Date();
  estado:number=-1;
  nombreGestion: string = "";
  tipoGestion:number=-1;
  tipoGestiones:TipoGestion[] = [];
  respuestaIa: string = "";//Solo visible y util para gestion web new
  matricula : string = "";
  codigoCita:string = "";
  telefono : string = "";
  displayedColumns: string[] =
  [
    "id",
    "tipo",
    "nombre",
    "telefono",
    "taller",
    "marca",
    "modelo",
    "puertas",
    "lamina",
    "email",
    "descr",
    "obser",
    "par1",
    "usuario",
    "empresa",
    "hoja",
    "matricula",
    "siniestro",
    "servicio",
    "created",
    "estado_contact"
  ];
  //columnas para la gestion de Outbound
  columnasOutbound:string[]=
  [
    "id","nombre","origen","marca","modelo","luna_afectada","fecha_creacion",
    "fecha_modificacion","telefono_contacto","matricula","estado"
  ];
  //columnas para la gestion de GestionWebNew
  columnasNew :string[] =
  [
    "id",
    "taller",
    "area_dañada",
    "thanks",
    "tipo_vehiculo",
    "codigo_cita",
    "fecha_hora_cita",
    "otra_area_dañada",//??
    "lugar_dañado",
    "aseguradora",
    "fecha_creacion",
    "fecha_modificacion",
    "nombre",
    "matrícula",
    "modelo",
    "tipo_daño",
    "telefono",
    "correo",
    "tipo_cristal",
    "tipo",
    "estado",
    "mayor_de_edad",
    "marca",
    "origen",
    "oper_cristal",
    "precisión_ia"
  ];
  columnasNewElse :string[] =
    [
      "id",
      "fecha_creacion",
      "fecha_modificacion",
      "nombre",
      "matrícula",
      "telefono",
      "correo",
      "politicas",//??
      "metodo_contacto",
      "codigo_postal",
      "tipo_vehiculo",
      "modelo",
      "tipo_daño",
      "comentario",
      "tipo_campaña",
      "motivo_contacto",
      "tipo",
      "tipo_cristal",
      "estado",
      "tipo_servicio",
      "origen",
      "titulo_campaña",
      "ip_usuario",
      "condiciones_noticias"
    ];
  columnasNew3 :string[] =
    [
      "id",
      "taller",
      "área_dañada",
      "thanks",
      "tipo_vehículo",
      "código_cita",
      "fecha_hora_cita",
      "otra_área_dañada",//??
      "lugar_dañado",
      "aseguradora",
      "fecha_creacion",
      "fecha_modificación",
      "nombre",
      "matrícula",
      "modelo",
      "tipo_daño",
      "teléfono",
      "correo",
      "tipo_cristal",
      "tipo",
      "estado",
      "mayor_de_edad",
      "marca",
      "origen",
      "oper_cristal",
      "precisión_ia"
    ];
  //Se usa para hacer la base de las columnas de gestionWeb
  columnasGestionWeb :string[] =
  [
    "id",
    "tipo",
    "nomcli",
    "teléfono",
    "fecha",
    "provincia",
    "taller",
    "marca",
    "modelo",
    "puertas",
    "lámina",
    "email",
    "descripción",
    "obser",
    "estado",
    "user",
    "empresa",
    "hoja",
    "matrícula",
    "siniestro",
    "servicio"
    ];
  columnasSegurCaixa :string[] =
    [
      "id",
      "expediente",
      "matrícula",
      "póliza",
      "descripción",
      "teléfono",
      "estado",
      "fecha_creación"
    ];
  columnasLineaDirecta : string[] =[
    "id",
    "nomcli",
    "dni",
    "población",
    "matrícula",
    "siniestro",
    "póliza",
    "fec_sin",
    "marca",
    "color",
    "año",
    "descripción",
    "estado",
    "user",
    "taller",
    "hoja"
  ]
  columnasCaser : string[] =[
    "id",
    "fecha_petición",
    "nomcli",
    "dni",
    "dirección",
    "teléfono",
    "población",
    "codigo_postal",
    "provincia",
    "matrícula",
    "siniestro",
    "póliza",
    "expediente",
    "fec_sin",
    "marca",
    "modelo",
    "color",
    "año",
    "descripción",
    "estado",
    "user",
    "taller",
    "hoja"
  ];

    columnasRauda : string[] =[
    "id",
    "taller",
    "area_dañada",
    "tipo_vehiculo",
    "codigo_cita",
    "fecha_hora_cita",
    "otra_area_dañada",//??
    "lugar_dañado",
    "aseguradora",
    "fecha_creacion",
    "fecha_modificacion",
    "nombre",
    "matrícula",
    "modelo",
    "tipo_daño",
    "telefono",
    "correo",
    "tipo_cristal",
    "estado",
    "marca",
    "origen",
    "usuario_creador"
  ];
  /* 
    Columnas que deben incluirse en todas las exportaciones
    Se ignora para la función exportarResultadosPorTipo()
  */
  /*columnasTodosTodos: string[] = 
  [
    "id","fecha_creacion","fecha_modificacion","nombre","matrícula","telefono","correo","politicas","metodo_contacto","codigo_postal","tipo_vehiculo","modelo","tipo_daño","comentario","tipo_campaña","motivo_contacto","tipo","tipo_cristal","estado","tipo_servicio","origen","titulo_campaña","ip_usuario","condiciones_noticias","codigo_cita","fecha_cita","hora_cita","delegacion","direccion","provincia","localidad","motivo_anulacion","fecha_anulacion","hora_anulacion","usuario_anulacion","usuario_gestion","usuario_creacion","usuario_modificacion","usuario_asignado","usuario_cierre","usuario_llamada","usuario_cita","usuario_estado","usuario_campaña","usuario_origen","usuario_tipo","usuario_tipo_cristal","usuario_servicio","usuario_ip","usuario_condiciones","usuario_codigo_cita",
    "taller","area_dañada"
  ];*/
  columnasTodosTodos: string[] = 
  [
    "id","fecha_creacion","fecha_modificacion","nombre","matrícula","telefono",
    "correo","politicas","metodo_contacto","codigo_postal","tipo_vehiculo","modelo",
    "tipo_daño","comentario","tipo","tipo_cristal","estado",
    "tipo_servicio","origen","codigo_cita","fecha_cita","hora_cita","delegacion","taller","area_dañada"
  ];
  peticionesEncontradas:PeticionWeb[]|PeticionWebNew[]|PeticionOutbound[]|PeticionWebRauda[] = [];
  dataSource : MatTableDataSource<PeticionWeb> | MatTableDataSource<PeticionWebNew> | MatTableDataSource<PeticionOutbound>  = new MatTableDataSource(this.peticionesEncontradas);

  formInic: any;
  controlGestion:string = "gestionWeb";
  mostrarCarga:boolean = false;

  @ViewChild(MatPaginator) paginator: MatTableDataSourcePaginator | null=null;
  @ViewChild(MatSort) sort: MatSort| null=null;
  constructor
  (
    public override dialogRef: MatDialogRef<Component>,
    @Inject(MAT_DIALOG_DATA) public override data: any | null,
    private dialogDetalle : MatDialog, // Additional parameter to override in the constructor
    private userService:UsuarioService,
    public peticionWebService: GestionPeticionService,
    public dialog:MatDialog,
  )
  {super(dialogRef, data);}

  ngOnInit()
  {
    this.token = this.data.token;
    this.formInic = this.data.form;
    const currentDate = new Date();
    currentDate.setMonth(currentDate.getMonth() - 1);
    const newData = new Date();
    newData.setDate(newData.getDate() + 1);
    this.fechaFin = newData;
    this.fechaInicio = currentDate;
    this.controlGestion = this.data.tipo?this.data.tipo.toString():"gestionWeb";
    this.configurarBusqueda();
  }
  limpiarTabla(){
    this.peticionesEncontradas = [];
    this.dataSource.data = this.peticionesEncontradas;
    this.refrescarDatasource();
  }
  configurarBusqueda()
  {
    switch(this.controlGestion)
    {
      case "gestionWeb":
        this.tipoGestiones =
        [
          {codigo:3,nombre:"MAPFRE SERVICIOS EMAIL"},
          {codigo:8,nombre:"CHATBOT"},
        ];
      break;
      case "gestionWebNew":
        this.tipoGestiones =
        [
          {codigo:-1,nombre:"TODOS"},
          {codigo:0,nombre:"Formularios Contacto"},
          {codigo:1,nombre:"Formulario Te Llamamos"},
          {codigo:2,nombre:"Formularios Servicios"},
          {codigo:3,nombre:"Formulario Pide Cita"},
          {codigo:4,nombre:"CHATBOT"},
        ];
      break;
      case "outbound": break;
      case "segurCaixa": break;
      case "rauda": break;
    }
  }
  //Abre el Dialog de detalle con la petición seleccionada.
  cargarDetalle(p:any)
  {
    this.dialogDetalle.open(DetallePeticionComponent,
    {
      data:
      {
        peticion: p.id,
        tipo:p.tipo,
        token:this.data.token,
        padre:this
      }
    }).afterClosed()
    .subscribe(result=>
    {
      if(result != undefined && result != null && result != "")
      {
        this.dialogRef.close(result);
      }
    })
  }
  //*Procesa el tipo de busqueda que se debe hacer
  buscar():void
  {
    if(this.checkFiltrosBusqueda())
    {
      this.peticionesEncontradas = [];
      this.mostrarCarga = true;
      switch (this.controlGestion)
      {
        case "outbound":
          this.buscarOutbound();
          break;
        case "gestionWebNew":
          this.buscarPWebNew();
          break;
        case "gestionWeb":
          this.buscarPWeb();
          break;
        case "segurCaixa":
          this.buscarSegurCaixa();
          break;
        case "lineaDirecta":
          this.buscarLinDirecta();
          break;
        case "caser":
          this.buscarCaser();
          break;
        case "rauda":
          this.buscarPRauda();
        break;
        default:
          this.formInic.mostrarArgumentario("Busqueda no contemplada",["El programa no está preparado para la gestión de peticiones de tipo "+this.controlGestion], false, true, true);
          break;
      }
    }
  }

  //si devuelve true, es que los filtros estan ok
  private checkFiltrosBusqueda():boolean
  {
    switch(this.controlGestion)
    {
      case "outbound":
      case "segurCaixa":
      case "lineaDirecta":
      case "caser":
        //solo comprueba el filtro de estado (y fechas)
        if(this.estado == -1)
        {
          this.formInic.mostrarArgumentario("Filtros obligatorios vacíos",["El campo de estado debe estar informado"], false, true, true);
          return false;
        }
        break;
      default:
        //Comprueba estado, y tipo de gestion.
        if(this.estado == -1)
        {
          this.formInic.mostrarArgumentario("Filtros obligatorios vacíos",["El campo de estado debe estar informado","El tipo de gestión debe de estar informado"], false, true, true);
          return false;
        }
        break;
    }
    return true;
  }
  //busca y carga las peticiones de Outbound
  buscarOutbound():void
  {
    let fIniParseada = this.fechaInicio.toISOString().split('T')[0];
    let fFinParseada = this.fechaFin.toISOString().split('T')[0];
    this.peticionWebService.getPeticionesOutbound(this.token, fIniParseada,fFinParseada,this.estado)
    .then(res=>
    {
      this.peticionesEncontradas = res;
      this.dataSource.data = this.peticionesEncontradas;
    })
    .finally(()=>
    {
      this.mostrarCarga = false;
      this.refrescarDatasource();
      if(this.peticionesEncontradas.length==0)
      {
        this.formInic.mostrarArgumentario("Sin resultados",["No se han encontrado datos con los filtros especificados."]);
      }
    })
    .catch(err=>{this.mostrarCarga = false;});
  }
  //busca y carga las peticiones de PeticionesWebNew
  buscarPWebNew():void
  {
    this.peticionWebService.saveEmailsChat(this.token).then(res => {
    }).finally(() => {
      let fIniParseada = this.fechaInicio.toISOString().split('T')[0];
      let fFinParseada = this.fechaFin.toISOString().split('T')[0];

      //creamos esto para especificar los otros filtros que pueden haber
      let mFiltros: Map<string, string> = new Map();
      // Añadir elementos
      //vamos agregando filtros si sus campos tienen valores validos
      if(this.telefono.trim()!="")mFiltros.set("telefono", this.telefono.trim());
      if(this.respuestaIa.trim()!="")mFiltros.set("respuesta_ia", this.respuestaIa.trim());
      if(this.matricula.trim()!="")mFiltros.set("matricula", this.matricula.trim());
      if(this.codigoCita.trim()!="")mFiltros.set("codigo_cita", this.codigoCita.trim());
      if(this.tipoGestion ==-1)
      {
       this.cargaPeticionesWebTodas(fIniParseada,fFinParseada,mFiltros);
      }
      else if(this.tipoGestion == 3){
        this.columnasNew = this.columnasNew3;
        this.peticionWebService.getPeticionesWebNew(this.token, fIniParseada,fFinParseada,this.estado, this.tipoGestion.toString(),mFiltros)
          .then(res=>
          {
            this.peticionesEncontradas = res;
            this.dataSource.data = this.peticionesEncontradas;
          })
          .finally(()=>
          {
            this.refrescarDatasource();
            this.mostrarCarga = false;
            if(this.peticionesEncontradas.length==0)
            {
              this.formInic.mostrarArgumentario("Sin resultados",["No se han encontrado datos con los filtros especificados."]);
              this.mostrarCarga=false;
            }
          })
          .catch(err=>
            {
              console.error("Error al buscar peticiones web new tipo 3:", err);
              this.mostrarCarga = false;
            });
      }else{
        this.columnasNew = this.columnasNewElse;
        this.peticionWebService.getPeticionesWebNewElse(this.token, fIniParseada,fFinParseada,this.estado, this.tipoGestion.toString(),mFiltros)
          .then(res=>
          {
            this.peticionesEncontradas = res;
            this.dataSource.data = this.peticionesEncontradas;
          })
          .finally(()=>
          {
            this.refrescarDatasource();
            this.mostrarCarga = false;
            if(this.peticionesEncontradas.length==0)
            {
              this.formInic.mostrarArgumentario("Sin resultados",["No se han encontrado datos con los filtros especificados."]);
              this.mostrarCarga=false;
            }
          })
          .catch(err=>{this.mostrarCarga = false;});
      }
    });
  }

  buscarPRauda():void
  {
    let fIniParseada = this.fechaInicio.toISOString().split('T')[0];
    let fFinParseada = this.fechaFin.toISOString().split('T')[0];

    //creamos esto para especificar los otros filtros que pueden haber
    let mFiltros: Map<string, string> = new Map();
    // Añadir elementos
    //vamos agregando filtros si sus campos tienen valores validos
    if(this.telefono.trim()!="")mFiltros.set("telefono", this.telefono.trim());
    if(this.matricula.trim()!="")mFiltros.set("matricula", this.matricula.trim());
    if(this.codigoCita.trim()!="")mFiltros.set("codigo_cita", this.codigoCita.trim());
    this.peticionWebService.getPeticionesRauda(this.token, fIniParseada,fFinParseada,this.estado,mFiltros)
      .then(res=>
      {
        this.peticionesEncontradas = res;
        this.dataSource.data = this.peticionesEncontradas;
      })
      .finally(()=>
      {
        this.refrescarDatasource();
        this.mostrarCarga = false;
        if(this.peticionesEncontradas.length==0)
        {
          this.formInic.mostrarArgumentario("Sin resultados",["No se han encontrado datos con los filtros especificados."]);
          this.mostrarCarga=false;
        }
      })
      .catch(err=>
        {
          console.error("Error al buscar peticiones web new tipo 3:", err);
          this.mostrarCarga = false;
        });
  }

  //busca y carga las peticiones web
  async buscarPWeb() {
    let fIniParseada = this.fechaInicio.toISOString().split('T')[0];
    let fFinParseada = this.fechaFin.toISOString().split('T')[0];
    switch (this.tipoGestion.toString()) {
      case "3":
        this.nombreGestion = "mapfreservicios";
        await this.peticionWebService.saveEmailsMapfre(this.token,this.userService.getNombreCuenta());
        break;
      case "8":
        this.nombreGestion = "chatbot";
        await this.peticionWebService.saveEmailsChat(this.token);
        break;
    }
    this.peticionWebService.getPeticionesWeb(this.token, fIniParseada, fFinParseada, this.estado, this.nombreGestion).then(
      res => {
        this.peticionesEncontradas = res;
        this.dataSource.data = this.peticionesEncontradas;
      }).finally(() => {
      this.refrescarDatasource();
      this.mostrarCarga = false;
      if (this.peticionesEncontradas.length == 0) {
        this.formInic.mostrarArgumentario("Sin resultados", ["No se han encontrado datos con los filtros especificados."]);
        this.mostrarCarga = false;
      }
    }).catch(err => {
      this.mostrarCarga = false;
    });
  }

  buscarSegurCaixa(){
    let fIniParseada = this.fechaInicio.toISOString().split('T')[0];
    let fFinParseada = this.fechaFin.toISOString().split('T')[0];

    let mFiltros: Map<string, string> = new Map();

    if(this.matricula.trim()!="")mFiltros.set("matricula", this.matricula.trim());
    this.peticionWebService.saveEmailsSegu(this.token,this.userService.getNombreCuenta()).then(res => {

    }).finally(() => {
      this.peticionWebService.getSegurCaixa(this.token, fIniParseada,fFinParseada,this.estado,mFiltros)
        .then(res=>
        {
          this.peticionesEncontradas = res;
          this.dataSource.data = this.peticionesEncontradas;
        })
        .finally(()=>
        {
          this.refrescarDatasource();
          this.mostrarCarga = false;
          if(this.peticionesEncontradas.length==0)
          {
            this.formInic.mostrarArgumentario("Sin resultados",["No se han encontrado datos con los filtros especificados."]);
            this.mostrarCarga=false;
          }
        })
        .catch(err=>{this.mostrarCarga = false;});
    });
  }

  buscarLinDirecta(){
    let fIniParseada = this.fechaInicio.toISOString().split('T')[0];
    let fFinParseada = this.fechaFin.toISOString().split('T')[0];

    let mFiltros: Map<string, string> = new Map();

    if(this.matricula.trim()!="")mFiltros.set("matricula", this.matricula.trim());
    this.peticionWebService.saveEmailsLineaDirecta(this.token,this.userService.getNombreCuenta()).then(res => {

    }).finally(() => {
      this.peticionWebService.getLineaDirecta(this.token, fIniParseada,fFinParseada,this.estado,mFiltros)
        .then(res=>
        {
          this.peticionesEncontradas = res;
          this.dataSource.data = this.peticionesEncontradas;
        })
        .finally(()=>
        {
          this.refrescarDatasource();
          this.mostrarCarga = false;
          if(this.peticionesEncontradas.length==0)
          {
            this.formInic.mostrarArgumentario("Sin resultados",["No se han encontrado datos con los filtros especificados."]);
            this.mostrarCarga=false;
          }
        })
        .catch(err=>{this.mostrarCarga = false;});
    });
  }

  buscarCaser(){
    let fIniParseada = this.fechaInicio.toISOString().split('T')[0];
    let fFinParseada = this.fechaFin.toISOString().split('T')[0];

    let mFiltros: Map<string, string> = new Map();

    if(this.matricula.trim()!="")mFiltros.set("matricula", this.matricula.trim());
    this.peticionWebService.saveEmailsLineaDirecta(this.token,this.userService.getNombreCuenta()).then(res => { //TODO CAMBIAR A LA FUCNION QUE SE REALIZE DE CASER

    }).finally(() => {
      this.peticionWebService.getCaser(this.token, fIniParseada,fFinParseada,this.estado,mFiltros)
        .then(res=>
        {
          this.peticionesEncontradas = res;
          this.dataSource.data = this.peticionesEncontradas;
        })
        .finally(()=>
        {
          this.refrescarDatasource();
          this.mostrarCarga = false;
          if(this.peticionesEncontradas.length==0)
          {
            this.formInic.mostrarArgumentario("Sin resultados",["No se han encontrado datos con los filtros especificados."]);
            this.mostrarCarga=false;
          }
        })
        .catch(err=>{this.mostrarCarga = false;});
    });
  }
  onPageChange(event: any)
  {
    if(this.paginator)
      this.paginator.pageIndex = event.pageIndex;
  }
  refrescarDatasource()
  {
    this.dataSource = new MatTableDataSource(this.peticionesEncontradas);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
  cargarHoja(row : any){
    this.formInic.idlinea = row.id;
    this.formInic.nombre = row.nomcli;
    this.formInic.asegurado.dni = row.dni;
    this.formInic.asegurado.direccion = row.poblacion;
    this.formInic.vehiculo.matricula = row.matricula;
    this.formInic.asegurado.siniestro = row.siniestro;
    this.formInic.asegurado.poliza = row.poliza;
    this.formInic.vehiculo.color = row.color;
    this.formInic.mensajeObser = row.observaciones;
    this.formInic.asegurado.fecSin= new Date(row.fec_sin);
    this.formInic.onEntradaLlamadaSelected("100000063", row.taller.toString().padStart(3, '0'));
    this.formInic.llamada.origen = "02";
    this.formInic.llamada.tipo = "100";
    this.dialogRef.close(true);
  }
  cambiarEstado(row : any){

    let estado = row["estado_contact"]
    let estado_2 = row["estado"]

    if (estado == 0 || estado_2 == 0){
      let paramArr = [];
      let param;
      
      switch (this.controlGestion)
      {
        case "outbound":
          param = {
            "id": row.id,
            "estado": "1",
            "usuario": this.userService.getNombreCuenta()
          }
          paramArr.push(param);
          break;
        case "gestionWebNew":
          param = {
            "id": row.id,
            "estado_contact": "1",
            "usuario": this.userService.getNombreCuenta()
          }
          paramArr.push(param);
          break;
        case "gestionWeb":
          param = {
            "id": row.id,
            "par1": "1"
          }
          paramArr.push(param);
          break;
        case "segurCaixa":
          param = {
            "id": row.id,
            "estado_contact": "1"
          }
          paramArr.push(param);
          break;
        case "lineaDirecta":
          param = {
            "id": row.id,
            "par1": "1"
          }
          paramArr.push(param);
          break;

          case "rauda":
          param = {
            "id": row.id,
            "estado_contact": "1",
            "usuario": this.userService.getNombreCuenta()
          }
          paramArr.push(param);
          break;
      }
      this.peticionWebService.UpdateEstadoWeb(this.token, this.controlGestion, paramArr, Number(row.tipo)).then(
        res => {
          this.dialog.open(AlertArgumentarioComponent,
            {
              data: {titulo: "OK",lineas:["Se ha marcado como gestionada!"], mostrarBtnCierre:true},
              disableClose:false
            }).afterClosed().subscribe(result => this.buscar());
        },
        err => {
          this.formInic.mostrarArgumentario("Error", [err.message], true, true, true);
        }
      )
    }else{
      this.formInic.mostrarArgumentario("Aviso", ["¡No se puede cambiar el estado porque no es 0!"], true, true, true);
    }
  }

/**
 * Exporta los resultados de la tabla a un archivo CSV.
 * Genera un archivo con el nombre basado en la fecha de inicio y fin.
 * El contenido es en base a las peticiones encontradas.
 * 
 * ANTES se mostraban solo las de su propio tipo
 * En caso de que se quiera volver a exportar por columnas específicas, 
 * usar la funcion exportarResultadosPorTipo() en la que se debe 
 * de especificar el tipo.
 * @return {void}
 */
  exportarResultados()
  {
    if(this.peticionesEncontradas.length>0)
    {
      const columnas = this.columnasTodosTodos;
      const nombreArchivo = `pet${this.controlGestion}_${this.fechaInicio.toISOString().split('T')[0]}_${this.fechaFin.toISOString().split('T')[0]}.csv`;

      // Monta el CSV
      const cabecera = columnas.join(';');
      const filas = this.dataSource.data.map((row: any) =>
        columnas.map(col => {
          let valor = row[col];
          // Traducciones específicas
          if (col === 'tipo') 
          {
            valor = this.traducirTipoGestion(row[col]);
          }
          if (col === 'estado' || col === 'estadoContact') 
          {
            valor = this.traducirEstado(row[col], row['tipo'], row);
          }
          // Evita undefined/null y escapa comillas
          return `"${valor !== undefined && valor !== null && valor !== "undefined" && valor !== "null" ? String(valor).replace(/"/g, '""') : ''}"`;
        })
        .join(';')
      );
      const csv = [cabecera, ...filas].join('\n');

      //creamos el archivo y el blob
      const archivo = new File([new Blob([csv], { type: 'text/csv;charset=utf-8;' })],nombreArchivo);
      const data = window.URL.createObjectURL(archivo);
      const link = document.createElement("a");
      link.href = data;
      link.download = nombreArchivo;
      link.click();
      //Mostramos mensaje conforme se ha descargado
      this.dialog.open(AlertArgumentarioComponent,
      {
        data: {titulo: "Exportación realizada",lineas:[""], mostrarBtnCierre:true, msgError: false},
        disableClose:false
      }).afterClosed();
    }
    else
    {
      //Mostramos mensaje de error   
      this.dialog.open(AlertArgumentarioComponent,
      {
        data: {titulo: "Exportación cancelada",lineas:["No hay datos para exportar"], mostrarBtnCierre:true, msgError: true},
        disableClose:false
      }).afterClosed();
    }
  }

  /**
 * Exporta los resultados de la tabla a un archivo CSV.
 * Genera un archivo con el nombre basado en la fecha de inicio y fin, 
 * y el tipo de gestión.
 * El contenido es en base a las peticiones encontradas.
 * @return {void}
 */
  exportarResultadosPorTipo()
  {
    if(this.peticionesEncontradas.length>0)
    {      
      let columnas: string[] = [];
      //Aqui se especificarán las columnas que Roser determine que deben aparecer siempre
      let columnasObligatorias : string[] = ["codigo_cita"];
      const nombreArchivo = `pet${this.controlGestion}_${this.fechaInicio.toISOString().split('T')[0]}_${this.fechaFin.toISOString().split('T')[0]}.csv`;
      switch(this.controlGestion)
      {
        case "gestionWebNew":
          columnas = this.columnasNew;
          break;
        case "gestionWeb":
          columnas = this.columnasGestionWeb;
          break;
        case "outbound":
          columnas = this.columnasOutbound;
          break;
        case "segurCaixa":
          columnas = this.columnasSegurCaixa;
          break;
        case "lineaDirecta":
          columnas = this.columnasLineaDirecta;
          break;
        case "caser":
          columnas = this.columnasCaser;
          break;
        default:
          columnas = this.columnasGestionWeb;
          break;
      }
      //Agregamos las columnas obligatorias ( si no lo estan ya)      
      for (const col of columnasObligatorias)
      {
        if(!columnas.includes(col))
        {
          columnas.push(col);
        }
      }

      // Monta el CSV
      const cabecera = columnas.join(';');
      const filas = this.dataSource.data.map((row: any) =>
        columnas.map(col => {
          let valor = row[col];
          // Traducciones específicas
          if (col === 'tipo') 
          {
            valor = this.traducirTipoGestion(row[col]);
          }
          if (col === 'estado' || col === 'estadoContact') 
          {
            valor = this.traducirEstado(row[col], row['tipo'], row);
          }
          // Evita undefined/null y escapa comillas
          return `"${valor !== undefined && valor !== null && valor !== "undefined" && valor !== "null" ? String(valor).replace(/"/g, '""') : ''}"`;
        })
        .join(';')
      );
      const csv = [cabecera, ...filas].join('\n');

      //creamos el archivo y el blob
      //const archivo = new File([new Blob([fileContent])],nombreArchivo);      
      const archivo = new File([new Blob([csv], { type: 'text/csv;charset=utf-8;' })],nombreArchivo);
      const data = window.URL.createObjectURL(archivo);
      const link = document.createElement("a");
      //creamos el enlace para iniciar la descarga
      //el enlace no es visible, es interno para el navegador
      link.href = data;
      link.download = nombreArchivo; // set a name for the file
      link.click();
      //Mostramos mensaje conforme se ha descargado
      this.dialog.open(AlertArgumentarioComponent,
      {
        data: {titulo: "Exportación realizada",lineas:[""], mostrarBtnCierre:true, msgError: false},
        disableClose:false
      }).afterClosed();
    }
    else
    {
      //Mostramos mensaje de error   
      this.dialog.open(AlertArgumentarioComponent,
      {
        data: {titulo: "Exportación cancelada",lineas:["No hay datos para exportar"], mostrarBtnCierre:true, msgError: true},
        disableClose:false
      }).afterClosed();
    }
  }


/**
 * Función que carga las peticiones de tipo 3 + las normales de peticionweb.
 * Luego, se mostrarán en la tabla.
 * @param fIniParseada string fecha de inicio en formato ISO
 * @param fFinParseada string fecha de fin en formato ISO
 * @param mFiltros Map<string,string> de los filtros a aplicar
 * @return {void}
 */
  cargaPeticionesWebTodas(fIniParseada:string,fFinParseada:string, mFiltros: Map<string, string>)
  {
     //hace que muestre tanto los del tipo 3 junto con el resto
        this.columnasNew = this.columnasNewElse;
        this.peticionWebService.getPeticionesWebNewElse(this.token, fIniParseada,fFinParseada,this.estado, this.tipoGestion.toString(),mFiltros)
          .then(res=>
          {
            this.peticionesEncontradas = res;
            this.dataSource.data = this.peticionesEncontradas;
            //Buscamos las peticiones de tipo 3 para luego agregarlas junto a las otras
            this.peticionWebService.getPeticionesWebNew(this.token, fIniParseada,fFinParseada,this.estado, "3",mFiltros)
            .then(resNew=>
            {
              let peticionesWebNew = resNew;
              let transformadas:PeticionWeb[] = [];
              try
              {
                resNew.forEach(peticionNew => 
                {
                  //transformadas.push(convertirPeticionWebNewAPeticionWeb(peticionNew));
                  transformadas.push(convertirPeticionWebAPeticionWebNew(peticionNew));
                });
              }
              catch(err)
              {
                console.error("Error al transformar PeticionWebNew a PeticionWeb:", err);
              }
              
              this.peticionesEncontradas = (this.peticionesEncontradas as PeticionWeb[]).concat(transformadas);              
              //ordenamos el listado completo por fecha de creación
              this.peticionesEncontradas.sort((a, b) => 
              {
                //Se tienen que parsear las fechas ya que son strings 
                const parseFecha = (fechaStr: string) => 
                {
                  if (!fechaStr) return 0;
                  // Espera formato dd/mm/yyyy hh:mi
                  const [fecha, hora] = fechaStr.split(' ');
                  if (!fecha) return 0;
                  const [dia, mes, anio] = fecha.split('/');
                  let horas = 0, minutos = 0;
                  if (hora) {
                    [horas, minutos] = hora.split(':').map(Number);
                  }
                  return new Date(
                    Number(anio),
                    Number(mes) - 1,
                    Number(dia),
                    horas,
                    minutos
                  ).getTime();
                };
                return parseFecha(b?.fecha_creacion) - parseFecha(a?.fecha_creacion);
              });
              this.dataSource.data = this.peticionesEncontradas;
            })
            .finally(()=>
            {
              this.refrescarDatasource();
              this.mostrarCarga = false;
              if(this.peticionesEncontradas.length==0)
              {
                this.formInic.mostrarArgumentario("Sin resultados",["No se han encontrado datos con los filtros especificados."]);
                this.mostrarCarga=false;
              }
            })
            .catch(err=>{this.mostrarCarga = false;});
          })
          .finally(()=>
          {
            this.refrescarDatasource();
            this.mostrarCarga = false;
            if(this.peticionesEncontradas.length==0)
            {
              this.formInic.mostrarArgumentario("Sin resultados",["No se han encontrado datos con los filtros especificados."]);
              this.mostrarCarga=false;
            }
          })
          .catch(err=>{this.mostrarCarga = false;});
  }
  
  /**
   * Devuelve el nombre del tipo de gestión asociado al código
   * Si no se encuentra , devuelve el valor pasadopor
   * @param tipo number | string código del tipo de gestión
   * @returns string nombre del tipo de gestión o el mismo código si no está definido
   */
  traducirTipoGestion(tipo: number | string): string 
  {
    return traducirTipoGestion(tipo);
  }

  /**
   * Traduce el estado de una petición al nombre asociado
   * Si el tipo de petición es 3 (WebNew), se tiene que revisar la propiedad estado_contact
   * @param numEstado number número del estado de la petición (si es tipo 3 , será undefined)
   * @param tipo number | string tipo de petición, si es 3 se utiliza estado_contact
   * @param mondongo any objeto que contiene el estado del contacto si tipo es 3
   * @returns string nombre del estado de la petición o nada si no se encuentra
   */
  traducirEstado(numEstado:number|string, tipo:number,mondongo:any):string | void
  {
    //Si es una peticion de tipo WebNew, se tiene que revisar el estado_contact
    if(tipo == 3)
    {
      if(mondongo.estado!=undefined){
        return traducirEstadoPeticionWeb(mondongo.estado);
      }
      else
      {
        return traducirEstadoPeticionWeb(mondongo.estado_contact);
      }
    }
    else if(numEstado!= undefined && numEstado != null)
    {
      return traducirEstadoPeticionWeb(numEstado);
    } 
  }
}
export interface TipoGestion
{
  codigo:number;
  nombre:string;
}
